// export interface DepartmentState {
//   departments: DepartmentDto[];
//   loading: boolean;
//   error: string | null;
//   selectedDepartment: DepartmentDto | null;
// }

export interface DepartmentDto {
  id: number;
  name: string;
  isActive: boolean;
  status: DepartmentStatus;
  createdAt: string;
  updatedAt: string;
  employeeCount: number;
  
  // Zorunlu alanlar (lateTolerationMinutes hariç)
  fixedShiftStartTime: string;
  fixedShiftEndTime: string;
  fixedShiftDays: string[] | string; // Backend'den string gelir, frontend'de array'e çevrilir
  lateTolerance: boolean;
  lateTolerationMinutes?: number; // Sadece bu opsiyonel
  defaultBreakDuration: number;
  maxBreakDuration: number;
}

export interface DepartmentCreateDTO {
  name: string;
  status?: DepartmentStatus;
  
  // Zorunlu alanlar (lateTolerationMinutes hariç)
  fixedShiftStartTime: string;
  fixedShiftEndTime: string;
  fixedShiftDays: string[] | string; // Frontend'den array gelir, backend'e string gönderilir
  lateTolerance: boolean;
  lateTolerationMinutes?: number; // Sadece bu opsiyonel
  defaultBreakDuration: number;
  maxBreakDuration: number;
}

export interface DepartmentUpdateDTO extends DepartmentCreateDTO {
  id: number;
  isActive?: boolean;
}

export enum DepartmentStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DELETED = "deleted"
}
